import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=6ded7ea6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Faq.vue"
export default component.exports